window.tiptapp = window.tiptapp || {};
tiptapp.views = tiptapp.views || {};

tiptapp.views.loginSuccess = (() => {
  const container = $('#login-success');
  const countOfHelpers = container.find('.helper-count');
  const requests = container.find('.request-container');
  const helperRequestText = container.find('.helper-count-text');
  const refreshBar = container.find('#refresh-bar');
  const avatarStack = container.find('.avatar-stack');
  const pulseCore = container.find('.waiting-pulse__core');
  const waitingPulse = container.find('.waiting-pulse');
  const restartButton = container.find('.waiting-pulse__restart');

  const PULSE_AVATAR_INTERVAL_MS = 2200;

  let listeningId;
  let hiddenAt = null;
  let listeningStartedAt;
  let devTimerIds = [];
  let pulseRotationId;
  let pulseRotationSrcs = [];
  let pulseRotationIdx = 0;
  let prevDoerCount = 0;

  const FAKE_DOERS = [
    {
      _id: 'fake-doer-1',
      name: { f: 'Alex' },
      thumbnail: 'https://i.pravatar.cc/96?img=12',
      scores: { doer: { ratings: { recentPosPctl: 4 }, pickUps: { recentDelayedPctl: 8, recentCanceledPctl: 3 } } },
    },
    {
      _id: 'fake-doer-2',
      name: { f: 'Bea' },
      thumbnail: 'https://i.pravatar.cc/96?img=32',
      scores: { doer: { ratings: { recentPosPctl: 7 }, pickUps: { recentDelayedPctl: 12, recentCanceledPctl: 5 } } },
    },
    {
      _id: 'fake-doer-3',
      name: { f: 'Cal' },
      thumbnail: 'https://i.pravatar.cc/96?img=15',
      scores: { doer: { ratings: { recentPosPctl: 10 }, pickUps: { recentDelayedPctl: 6, recentCanceledPctl: 2 } } },
    },
    {
      _id: 'fake-doer-4',
      name: { f: 'Dani' },
      thumbnail: 'https://i.pravatar.cc/96?img=47',
      scores: { doer: { ratings: { recentPosPctl: 15 }, pickUps: { recentDelayedPctl: 18, recentCanceledPctl: 9 } } },
    },
    {
      _id: 'fake-doer-5',
      name: { f: 'Eli' },
      thumbnail: 'https://i.pravatar.cc/96?img=68',
      scores: { doer: { ratings: { recentPosPctl: 6 }, pickUps: { recentDelayedPctl: 9, recentCanceledPctl: 4 } } },
    },
    {
      _id: 'fake-doer-6',
      name: { f: 'Fin' },
      thumbnail: 'https://i.pravatar.cc/96?img=22',
      scores: { doer: { ratings: { recentPosPctl: 11 }, pickUps: { recentDelayedPctl: 14, recentCanceledPctl: 6 } } },
    },
    {
      _id: 'fake-doer-7',
      name: { f: 'Gus' },
      thumbnail: 'https://i.pravatar.cc/96?img=51',
      scores: { doer: { ratings: { recentPosPctl: 8 }, pickUps: { recentDelayedPctl: 10, recentCanceledPctl: 4 } } },
    },
    {
      _id: 'fake-doer-8',
      name: { f: 'Hugo' },
      thumbnail: 'https://i.pravatar.cc/96?img=14',
      scores: { doer: { ratings: { recentPosPctl: 13 }, pickUps: { recentDelayedPctl: 7, recentCanceledPctl: 3 } } },
    },
  ];

  const AWAY_THRESHOLD_MS = 5000;
  const POLL_SHORT_MS = 8000;
  const POLL_LONG_MS = 30000;
  const AD_AGE_THRESHOLD_MS = 5 * 60 * 1000;
  const MAX_LISTEN_MS = 15 * 60 * 1000;

  function restartRefreshBar(durationMs) {
    refreshBar.css('animation', 'none');
    refreshBar[0] && refreshBar[0].offsetWidth; // eslint-disable-line no-unused-expressions
    refreshBar.css('animation', `refresh-bar-deplete ${durationMs}ms linear forwards`);
  }

  function intervalForAd(ad) {
    if (!ad || !ad.created || typeof ad.created !== 'number') return POLL_SHORT_MS;
    const age = Date.now() - ad.created;
    return age > AD_AGE_THRESHOLD_MS ? POLL_LONG_MS : POLL_SHORT_MS;
  }

  function renderAvatarStack(doers) {
    const MAX_VISIBLE = 5;
    const visible = doers.slice(0, MAX_VISIBLE);
    const overflow = doers.length - visible.length;
    const existingSrcs = avatarStack
      .find('.avatar-stack__item')
      .map((_, el) => el.getAttribute('data-src'))
      .get();

    const items = visible.map(d => {
      const src = d.thumbnail || '';
      const alt = (d.name && d.name.f) || '';
      const isNew = !existingSrcs.includes(src);
      const cls = isNew ? 'avatar-stack__item' : 'avatar-stack__item avatar-stack__item--settled';
      return `<img class="${cls}" data-src="${src}" src="${src}" alt="${alt}">`;
    });
    const overflowEl = overflow > 0 ? `<div class="avatar-stack__overflow">+${overflow}</div>` : '';
    avatarStack.html(items.join('') + overflowEl);
  }

  function clearAvatarStack() {
    avatarStack.empty();
  }

  function trackDoerListChange(newCount) {
    if (newCount !== prevDoerCount) {
      tiptapp.analytics.trackEvent('web_doer_list_changed', {
        newCount,
        prevCount: prevDoerCount,
        delta: newCount - prevDoerCount,
      });
      prevDoerCount = newCount;
    }
  }

  function showNextPulseAvatar() {
    if (pulseRotationSrcs.length === 0) return;
    const src = pulseRotationSrcs[pulseRotationIdx % pulseRotationSrcs.length];
    pulseRotationIdx += 1;

    const incoming = $(`<img class="waiting-pulse__avatar" src="${src}" alt="">`);
    pulseCore.append(incoming);
    // Force reflow so the transition picks up the opacity change.
    incoming[0] && incoming[0].offsetWidth; // eslint-disable-line no-unused-expressions
    incoming.addClass('waiting-pulse__avatar--visible');

    const outgoing = pulseCore.find('.waiting-pulse__avatar').not(incoming);
    outgoing.removeClass('waiting-pulse__avatar--visible');
    setTimeout(() => outgoing.remove(), 500);
  }

  function startPulseAvatarRotation(doers) {
    const srcs = doers.map(d => d.thumbnail).filter(Boolean);
    const sameRoster = srcs.length === pulseRotationSrcs.length && srcs.every((s, i) => s === pulseRotationSrcs[i]);
    if (sameRoster && pulseRotationId) return;

    pulseRotationSrcs = srcs;
    if (srcs.length === 0) {
      stopPulseAvatarRotation();
      return;
    }

    pulseCore.addClass('waiting-pulse__core--has-avatar');
    if (!pulseRotationId) {
      pulseRotationIdx = 0;
      showNextPulseAvatar();
      pulseRotationId = setInterval(showNextPulseAvatar, PULSE_AVATAR_INTERVAL_MS);
    }
  }

  function stopPulseAvatarRotation() {
    clearInterval(pulseRotationId);
    pulseRotationId = undefined;
    pulseRotationSrcs = [];
    pulseRotationIdx = 0;
    pulseCore.removeClass('waiting-pulse__core--has-avatar');
    pulseCore.find('.waiting-pulse__avatar').remove();
  }

  function pausePulseAvatarRotation() {
    clearInterval(pulseRotationId);
    pulseRotationId = undefined;
  }

  function resumePulseAvatarRotation() {
    if (pulseRotationId || pulseRotationSrcs.length === 0) return;
    pulseRotationId = setInterval(showNextPulseAvatar, PULSE_AVATAR_INTERVAL_MS);
  }

  function enterTimedOutState() {
    pausePulseAvatarRotation();
    waitingPulse.addClass('waiting-pulse--timed-out');
    refreshBar.css('animation', 'none');
    pulseCore.find('.waiting-pulse__avatar').remove();
    pulseCore.removeClass('waiting-pulse__core--has-avatar');
    restartButton.show();
  }

  function exitTimedOutState() {
    waitingPulse.removeClass('waiting-pulse--timed-out');
    restartButton.hide();
  }

  async function refreshAdStatus(ad, jwt) {
    let statusData;
    try {
      statusData = await $.ajax({
        type: 'GET',
        url: `/api/status/${ad._id}`,
        headers: { authorization: jwt },
        contentType: 'application/json',
      });
    } catch (error) {
      console.error('Error fetching ad status:', error); // eslint-disable-line
      return;
    }

    const { numberOfHelpers, doerIds } = statusData || {};

    if (!numberOfHelpers) {
      requests.hide();
      clearAvatarStack();
      stopPulseAvatarRotation();
      trackDoerListChange(0);
      return;
    }

    countOfHelpers.text(numberOfHelpers);
    countOfHelpers.show();
    helperRequestText.html(window.i18next.t(numberOfHelpers > 1 ? 'new_requests' : 'new_request'));
    requests.show();

    if (!doerIds || doerIds.length === 0) {
      clearAvatarStack();
      stopPulseAvatarRotation();
      trackDoerListChange(0);
      return;
    }

    let usersData;
    try {
      usersData = await $.ajax({
        type: 'GET',
        url: `/api/users?ids=${doerIds.join(',')}`,
        headers: { authorization: jwt },
        contentType: 'application/json',
      });
    } catch (error) {
      console.error('Error fetching doers:', error); // eslint-disable-line
      return;
    }

    if (!usersData || !usersData.users || usersData.users.length === 0) return;

    const orderedUsers = [...doerIds]
      .reverse()
      .map(id => usersData.users.find(u => u._id === id))
      .filter(Boolean);

    renderAvatarStack(orderedUsers);
    startPulseAvatarRotation(orderedUsers);
    trackDoerListChange(orderedUsers.length);
  }

  function scheduleRefresh(ad, jwt) {
    if (Date.now() - listeningStartedAt >= MAX_LISTEN_MS) {
      enterTimedOutState();
      return;
    }
    const interval = intervalForAd(ad);
    restartRefreshBar(interval);
    listeningId = setTimeout(() => {
      listeningId = undefined;
      refreshAdStatus(ad, jwt);
      scheduleRefresh(ad, jwt);
    }, interval);
  }

  function onVisibilityChange() {
    const ad = tiptapp.store.ad.get();
    const user = tiptapp.getUser();

    if (document.hidden) {
      hiddenAt = Date.now();
      clearTimeout(listeningId);
      listeningId = undefined;
      refreshBar.css('animation', 'none');
      pausePulseAvatarRotation();
      return;
    }

    const awayMs = hiddenAt ? Date.now() - hiddenAt : Infinity;
    hiddenAt = null;
    if (!user) return;

    if (awayMs >= AWAY_THRESHOLD_MS) {
      refreshAdStatus(ad, user.jwt);
    }
    scheduleRefresh(ad, user.jwt);
    resumePulseAvatarRotation();
  }

  function unlistenForHelpers() {
    clearTimeout(listeningId);
    listeningId = undefined;
  }

  function listenForHelpers() {
    if (listeningId) return;

    const ad = tiptapp.store.ad.get();
    const user = tiptapp.getUser();

    if (!ad || Object.keys(ad).length === 0) {
      console.error('job is disabled: ad not found'); // eslint-disable-line
      return;
    }
    if (ad.state === 2) {
      console.error('job is disabled: helper already assigned'); // eslint-disable-line
      return;
    }
    if (!user) {
      console.error('job is disabled: user missing in sessionStore'); // eslint-disable-line
      return;
    }

    listeningStartedAt = Date.now();
    refreshAdStatus(ad, user.jwt);
    scheduleRefresh(ad, user.jwt);
  }

  function applyFakeStep(doers) {
    if (doers.length === 0) {
      requests.hide();
      clearAvatarStack();
      stopPulseAvatarRotation();
      return;
    }
    countOfHelpers.text(doers.length);
    countOfHelpers.show();
    helperRequestText.html(window.i18next.t(doers.length > 1 ? 'new_requests' : 'new_request'));
    requests.show();
    renderAvatarStack(doers);
    startPulseAvatarRotation(doers);
  }

  function devFakeProgression(opts) {
    const stepMs = (opts && opts.stepMs) || 8000;

    clearTimeout(listeningId);
    listeningId = undefined;
    document.removeEventListener('visibilitychange', onVisibilityChange);
    devTimerIds.forEach(clearTimeout);
    devTimerIds = [];

    clearAvatarStack();
    stopPulseAvatarRotation();
    requests.hide();

    const steps = [
      { at: 0, doers: [] },
      { at: stepMs, doers: FAKE_DOERS.slice(0, 1) },
      { at: stepMs * 2, doers: FAKE_DOERS.slice(0, 3) },
      { at: stepMs * 3, doers: FAKE_DOERS.slice(0, 5) },
      { at: stepMs * 4, doers: FAKE_DOERS.slice(0, 8) },
    ];

    steps.forEach(({ at, doers }) => {
      devTimerIds.push(
        setTimeout(() => {
          restartRefreshBar(stepMs);
          applyFakeStep(doers);
        }, at)
      );
    });
  }

  restartButton.click(() => {
    const ad = tiptapp.store.ad.get();
    const user = tiptapp.getUser();
    if (!ad || !user) return;
    exitTimedOutState();
    listeningStartedAt = Date.now();
    resumePulseAvatarRotation();
    refreshAdStatus(ad, user.jwt);
    scheduleRefresh(ad, user.jwt);
  });

  $('#dynamic-link').click(() => {
    const dynamicLink = tiptapp.store.dynamicLink.get();

    if (/iPhone|iPad|iPod/.test(navigator.platform)) {
      clipboard.writeText(dynamicLink).then(
        () => console.log('clipboard success'), // eslint-disable-line
        () => console.log('clipboard error') // eslint-disable-line
      );
    }

    window.open(dynamicLink, '_blank');
    tiptapp.analytics.trackEvent('web_tap_dynamic_link');
  });

  return {
    container,
    display() {
      container.css('display', 'flex');
      exitTimedOutState();
      prevDoerCount = 0;
      listenForHelpers();
      document.addEventListener('visibilitychange', onVisibilityChange);
    },
    hide() {
      unlistenForHelpers();
      listeningStartedAt = undefined;
      prevDoerCount = 0;
      clearAvatarStack();
      stopPulseAvatarRotation();
      exitTimedOutState();
      document.removeEventListener('visibilitychange', onVisibilityChange);
    },
    devFakeProgression,
    devForceTimedOut() {
      clearTimeout(listeningId);
      listeningId = undefined;
      devTimerIds.forEach(clearTimeout);
      devTimerIds = [];
      enterTimedOutState();
    },
  };
})();
